<script setup>
import { onMounted, ref } from 'vue'
import { translate } from '@/assets/translations'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

// Inicialización de Swiper al montar el componente
onMounted(() => {
  new Swiper('.testimonial__container', {
    loop: true,
    spaceBetween: 24,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      568: {
        slidesPerView: 1,
      }
    }
  })
})
</script>


<template lang="">
    <section class="testimonial section" id="testimonials">
        <h2 class="section__title">{{ translate("testimonials").name }}</h2>
        <span class="section__subtitle">{{ translate("testimonials").content }}</span>

        <div class="container section__border">
            <div class="testimonial__container swiper">
                <div class="swiper-wrapper">

                    <div class="testimonial__content swiper-slide">
                        <p class="testimonial__description">
                            "{{ translate("testimonials").test1 }}"
                        </p>

                        <div>
                            <h3 class="testimonial__name">Carlos Alberto Nobile</h3>
                                <span class="testimonial__subtitle">{{ translate("testimonials").client }}</span>
                        </div>
                    </div>

                    <div class="testimonial__content swiper-slide">
                        <p class="testimonial__description">
                            "{{ translate("testimonials").test2 }}"
                        </p>

                        <div>
                            <h3 class="testimonial__name">Marcelo Pires</h3>
                                <span class="testimonial__subtitle">{{ translate("testimonials").client }}</span>
                        </div>
                    </div>

                    <div class="testimonial__content swiper-slide">
                        <p class="testimonial__description">
                            "{{ translate("testimonials").test3 }}"
                        </p>

                        <div>
                            <h3 class="testimonial__name">Paula Guastella</h3>
                                <span class="testimonial__subtitle">{{ translate("testimonials").client }}</span>
                        </div>
                    </div>

                    <div class="testimonial__content swiper-slide">
                        <p class="testimonial__description">
                            "{{ translate("testimonials").test4 }}"
                        </p>

                        <div>
                            <h3 class="testimonial__name">Dra. Benítez Alelí</h3>
                                <span class="testimonial__subtitle">{{ translate("testimonials").client }}</span>
                        </div>
                    </div>

                </div>

                <div class="swiper-button-next">
                    <i class="ri-arrow-right-s-line"></i>
                </div>
                <div class="swiper-button-prev">
                    <i class="ri-arrow-left-s-line"></i>
                </div>
            </div>
        </div>

        <img src="../../public/img/shape-wawes.svg" alt="Testimonial image" class="testimonial__img">
    </section>
</template>


<style scoped>
    
</style>